import React, { useState } from 'react';
import { Form, Row, Col, Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Form that ckecks for violation by delict ID
 *
 * @component - DelictIdData
 * @parentComponent - ViolationCheck
 */

interface Props {
  dataCheck: (data: DelictIdData) => void;
  clearDirtyState?: () => void;
  setDirtyState: () => void;
}

interface DelictIdData {
  delictId: string;
  personalNumber: string;
}

const DelictIdForm = (props: Props) => {
  const { t } = useTranslation();

  const [delictId, setDelictId] = useState('');
  const setDelictIdHandler = (event: any) => {
    setDelictId(event.target.value);
  };

  const [personalNumber, setPersonalNumber] = useState('');
  const setPersonalNumberHandler = (event: any) => {
    setPersonalNumber(event.target.value);
  };

  const checkData = () => {
    props.dataCheck({
      delictId: delictId,
      personalNumber: personalNumber
    });
    if (props.clearDirtyState) {
      props.clearDirtyState();
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') checkData();
  };

  const resetForm = () => {
    setDelictId('');
    setPersonalNumber('');
    props.setDirtyState();
  };

  return (
    <Container className="DelictIdForm fadeIn">
      <Form as={Row} className="formControl">
        <Form.Group as={Col} md={4} className="formGroup">
          <Form.Label className="label">{t('DelictIdForm.label')}</Form.Label>
          <Form.Control size="sm" value={delictId} onChange={setDelictIdHandler} onKeyPress={handleKeyPress} />
        </Form.Group>
        <Form.Group as={Col} md={4} className="formGroup">
          <Form.Label className="label">{t('PersonalDataForm.label')}</Form.Label>
          <Form.Control
            size="sm"
            value={personalNumber}
            onChange={setPersonalNumberHandler}
            onKeyPress={handleKeyPress}
          />
        </Form.Group>
        <Form.Group as={Col} md={4} className="buttonControl">
          <Button onClick={resetForm} variant="outline-success" className="resetBtn" size="sm">
            {t('DelictIdForm.reset')}
          </Button>
          <Button onClick={checkData} variant="success" size="sm">
            {t('DelictIdForm.button')}
          </Button>
        </Form.Group>
      </Form>
    </Container>
  );
};

export default DelictIdForm;
